import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  isDialogOpen: boolean;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  isDialogOpen: false
};

export const isReadonlyReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_IS_READONLY_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_IS_READONLY_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_IS_READONLY_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
